import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { PermissionsService } from './permissions.service';

export const RoleGuard: CanActivateFn = (route, state) => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  // extract the role from the route data
  const requiredRoles = route.data['roles'] as Array<string>;

  const hasRequiredRole = permissionsService.hasRole(requiredRoles);
  if (!hasRequiredRole) {
    router.navigate(['/discover']);
    return of(false);
  }
  return of(true);
};
